import { isNil } from 'lodash'
import {
  MapFeatureType,
  useFeatureInteractionContext,
} from 'pages/siteView/siteMap/contexts/FeatureInteractionContext'
import { useTilesetMapFeatureHelpers } from 'pages/siteView/siteMap/tilesetMap/features/useTilesetMapFeatureHelpers'
import React, { FC } from 'react'
import styled from 'styled-components'
import { SiteFeaturePrimitive } from 'types'

import { SVNumberInput } from './SVNumberInput'

const RotationInputSection = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  align-items: center;
`

interface RotationInputProps {
  feature: SiteFeaturePrimitive
  featureType: MapFeatureType
}

export const RotationInput: FC<RotationInputProps> = (props) => {
  const { setSelectedFeature } = useFeatureInteractionContext()
  const { updateFeaturePrimitive } = useTilesetMapFeatureHelpers()

  const onChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    let degree: number | null = parseFloat(e.target.value)
    if (isNaN(degree)) degree = 0
    degree = (degree + 360) % 360
    const newRotation = props.feature.rotation
    newRotation[index] = degree
    const newFeature = {
      ...props.feature,
      rotation: newRotation,
    }
    updateFeaturePrimitive(newFeature, 'rotation_' + index)
    setSelectedFeature(
      isNil(newFeature.unit_id)
        ? {
            type: MapFeatureType.Unknown,
            featureID: newFeature.id,
          }
        : {
            type: MapFeatureType.Unit,
            unitID: newFeature.unit_id,
          }
    )
  }

  return (
    <RotationInputSection>
      <text>Rotate</text>
      x:
      <SVNumberInput
        id={'x'}
        value={props.feature.rotation[0]}
        step={1}
        onChange={(e) => onChange(e, 0)}
        width={60}
      />
      y:
      <SVNumberInput
        id={'y'}
        value={props.feature.rotation[1]}
        step={1}
        onChange={(e) => onChange(e, 1)}
        width={60}
      />
      z:
      <SVNumberInput
        id={'z'}
        value={props.feature.rotation[2] as number}
        step={1}
        onChange={(e) => onChange(e, 2)}
        width={60}
      />
    </RotationInputSection>
  )
}
